<template>
  <b-navbar toggleable="lg" type="dark" variant="info" style="background-color: #00445E !important">
    <b-navbar-brand href="/" style="margin-top: 0; padding-top: 0">
      <div style="font-family: Arial, Helvetica, sans-serif; height: 26px" class="text-left">
        <div style="font-size: 12px; height: 12px">NETTI</div>
        <div style="font-size: 14px; height: 14px"><strong>PYÖRÄ</strong></div>
      </div>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :active="$route.query.active === 'advanced-search' || $route.name === 'advanced-search'" to="/advanced-search"><span>{{langNavBar.advanceSearch[locale]}}</span></b-nav-item>
        <b-nav-item :active="$route.query.active === 'stores' || $route.name === 'stores'" to="/stores"><span>{{langNavBar.stores[locale]}}</span></b-nav-item>
        <b-nav-item v-if="$store.getters.isAuthenticated" :active="$route.query.active === 'account' || $route.name === 'account'"  to="/account"><span>{{langNavBar.account[locale]}}</span></b-nav-item>
        
        <b-nav-item :active="$route.query.active === 'create' || $route.name === 'create'"  to="/create"><span class="btn btn-dark" style="color: inherit; padding: 0 5px 0 5px">{{langNavBar.createPost[locale]}}</span></b-nav-item>
        <!-- Navbar dropdowns -->
        <b-nav-item-dropdown :text="locale" right>
          <b-dropdown-item @click.stop="$store.commit('LOCALE', 'en')">en</b-dropdown-item>
          <b-dropdown-item @click.stop="$store.commit('LOCALE', 'fi')">fi</b-dropdown-item>
          <!--
          <b-dropdown-item @click.stop="$store.commit('LOCALE', 'sv')">sv</b-dropdown-item>
          <b-dropdown-item @click.stop="$store.commit('LOCALE', 'ru')">ru</b-dropdown-item>
          -->
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown v-if="$store.getters.isAuthenticated" :text="`${langNavBar.hi[locale]} ${authenticatedUser ? authenticatedUser.name:'......'}`" right>
          <b-dropdown-item to="/account"><font-awesome-icon icon="user-circle"/> {{langNavBar.profile[locale]}}</b-dropdown-item>
          <b-dropdown-item @click.stop="$store.dispatch('LOGOUT')"><font-awesome-icon icon="sign-out-alt"/> {{langNavBar.logOut[locale]}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-else :active="$route.query.active === 'login' || $route.name === 'login'" to="/login" right>{{langNavBar.logIn[locale]}}</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import {CITIES} from '@/store/constant';
import { mapState } from 'vuex';
import langNavBar from '@/store/lang/navBar';

export default {
  name: "NavBar",
  data() {
    return {
      CITIES, langNavBar
    }
  },
  computed: mapState({
    locale: state => state.locale,
    authenticatedUser: state => state.authenticatedUser
  })
}
</script>

<style scoped lang="scss">
a {
  a {
    color: inherit;
    text-decoration: inherit;
  }
}

.btn-dark {
  background: rgba(0,0,0,0.2);
  border-color: rgba(0,0,0,0.2);
}

.active {
  font-weight: bold;
  .btn-dark {
    background: gray;
    font-weight: bold;
  }
}
</style>


